import { useMemo } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { useAcceptPriceChange } from "src/hooks/acceptPriceChange";
import { maxStakeExceeded, placeBetDisabled } from "src/rules/bet";
import { useTranslation } from "src/hooks/translation";
import selectionsStore from "src/stores/selections";
import betBuilderStore from "src/stores/betBuilder";
import Spinner from "src/common/components/spinner";
import upperDataStore from "src/stores/upperData";
import { useConfig } from "src/hooks/config";
import mainStore, { storeSetVerificationDisabledManually } from "src/stores/main";
import { getPlaceBetLabel } from "./helpers";

import "./style.scss";

interface IProps {
	onClick(): void;
}

const PlaceBetButton = ({ onClick }: IProps) => {
	const t = useTranslation();
	const config = useConfig();
	const { selections } = useRecoilValue(selectionsStore);
	const upperDataState = useRecoilValue(upperDataStore);
	const [mainState] = useRecoilState(mainStore);
	const bbState = useRecoilValue(betBuilderStore);
	const [isPriceAccepted, acceptPriceChange] = useAcceptPriceChange();

	const handleVerification = async () => {
		const result = await upperDataState.verificationResolver?.login();
		result?.success && result.data?.skipped && storeSetVerificationDisabledManually(true);
	}

	const isPlaceSuperbet = useMemo(
		() => mainState.isSuperbet && maxStakeExceeded(config, selections, mainState),
		[config, selections, mainState]
	);

	if (!isPriceAccepted)
		return (
			<button className="B-bet-block-button B-odd-change" onClick={acceptPriceChange}>
				{t("Accept Odd Changes")}
			</button>
		);

	const disabled = placeBetDisabled(config, selections, mainState, upperDataState, bbState);
	const placeBetLabel = getPlaceBetLabel(config, mainState);

	if (
		config.verification?.enabled &&
		!upperDataState.verificationResponse?.success &&
		!mainState.verificationDisabledManually &&
		!upperDataState.userId
	)
		return (
			<button onClick={handleVerification} className="B-bet-block-button B-verification-btn">
				{t(config.verification.placeBetText || "Place bet")}
			</button>
		);

	if (isPlaceSuperbet)
		return (
			<button
				disabled={disabled}
				className="B-bet-block-button B-place-superbet-button"
				onClick={onClick}
			>
				{t("Place Superbet")} {mainState.placeBetLoading && <Spinner />}
			</button>
		);

	return (
		<button disabled={disabled} className="B-bet-block-button B-place-bet-button" onClick={onClick}>
			{t(placeBetLabel)} {mainState.placeBetLoading && <Spinner />}
		</button>
	);
};

export default PlaceBetButton;
